﻿import { defineStore } from 'pinia';
import { ref } from 'vue';

// A store used to preselect the piping class (size) or line size from the specializedUIButton. The selected options are used when initializing the pipe class store, then discarded
export const usePreselectPipeClassStore = defineStore('preselectPipeClass', () => {
    const pipingClassId = ref<number | null>(null);
    const pipingClassSizeId = ref<number | null>(null);
    const lineSizeId = ref<number | null>(null);

    function setPipingClass(value: number | null) {
        pipingClassId.value = value;
    }

    function setPipingClassSize(value: number | null) {
        pipingClassSizeId.value = value;
    }

    function setLineSize(value: number | null) {
        lineSizeId.value = value;
    }

    return {
        pipingClassId,
        pipingClassSizeId,
        lineSizeId,
        setPipingClass,
        setPipingClassSize,
        setLineSize
    };
});

export type PreselectPipeClassStore = ReturnType<typeof usePreselectPipeClassStore>;
